import { css } from 'aphrodite';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../../web/components-v2/Button';
import { useIsCoffeeMobile } from '../../../shell/CoffeeMobileRouteGuard';
import { LeadServedSource } from '../../../viewModels/queue';
import { styleSheet } from './styles';

interface IProps {
	companyId?: string;
	companyName?: string;
}

// Plain text on phones: the queue isn't a mobile route, so the route guard would bounce the tap and drop filters.
export const CompanyLink: React.FC<IProps> = ({ companyId, companyName }) => {
	const isMobile = useIsCoffeeMobile();
	if (!companyId || !companyName || isMobile) {
		return (
			<span className={css(companyName ? styleSheet.plainName : styleSheet.muted)}>{companyName || 'Unknown'}</span>
		);
	}
	return (
		<div className={css(styleSheet.aboveRow)}>
			<Button asChild variant='link' styles={[styleSheet.companyName]}>
				<Link to={{ pathname: '/queue', search: `?from=${LeadServedSource.CallLog}&companyId=${companyId}` }}>
					{companyName}
				</Link>
			</Button>
		</div>
	);
};
